import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../Axios";
import useAuth from "../../contexts/UserContext.tsx";
import { TopWidgetsStudentsProgress } from "../../components/TopWidgetsStudentProgress/TopWidgetsStudentsProgress.jsx";
import { StudentProgressDataTable } from "../../components/StudentProgressDataTable/StudentProgressDataTable.jsx";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  addCourse,
  addCourseName,
  selectCourse,
  selectCourseName,
} from "../../features/student/studentSlice.js";
import { toast } from "sonner";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const StudentProgress = () => {
  const dispatch = useDispatch();
  const crs = useSelector(selectCourse);
  useSelector(selectCourseName);

  const { id } = useParams();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [schoolCourses, setSchoolCourses] = useState();
  const [course, setCourse] = useState();
  const [studentDetails, setStudentDetails] = useState();
  const [schoolData, setSchoolData] = useState();
  const [school, setSchool] = useState("");
  const showBack = user.view_access_list.isIndividualSchool;

  const getSchoolNameByID = async () => {
    await axiosInstance
      .post("getSchoolNameByID", {
        school_id: id,
        user_id: user.user_id,
        auth_token: user.auth_token,
      })
      .then((res) => {
        if (res.data.data.message === "Invalid User") {
          toast.error("Invalid User");
          logout();
          return;
        }
        setSchool(res.data.data.school_name[0].school_name);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getCourses = async () => {
    try {
      const res = await axiosInstance.post("/getCourseForSchools", {
        auth_token: user.auth_token,
        school_id: id,
      });
      setSchoolCourses(res.data.data.crs_details);

      if (crs) {
        setCourse(crs);
        handleSubmitCourseSelected(crs);
        return;
      } else {
        dispatch(addCourse(res.data.data.crs_details[0].crs_id));
        dispatch(addCourseName(res.data.data.crs_details[0].crs_title));

        setCourse(res.data.data.crs_details[0].crs_id);
        handleSubmitCourseSelected(res.data.data.crs_details[0].crs_id);
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  const getStudentCourseData = (e) => {
    e.preventDefault();
    dispatch(addCourse(course));
    dispatch(
      addCourseName(
        schoolCourses.find((crs) => crs.crs_id === course).crs_title
      )
    );
    handleSubmitCourseSelected(course);
  };

  const handleSubmitCourseSelected = async (selected_course) => {
    try {
      const res = await axiosInstance.post("/getStudentProgressForSchool", {
        auth_token: user.auth_token,
        school_id: id,
        crs_id: selected_course,
      });
      setStudentDetails(
        res.data.data.student_excs_summary.Student_details.map((student) => ({
          ...student,
          completed: parseInt(student.completed),
          notstarted: parseInt(student.notstarted),
          struggling: parseInt(student.struggling),
          started: parseInt(student.started),
          name: student.name.charAt(0).toUpperCase() + student.name.slice(1),
        }))
      );
      setSchoolData(res.data.data.student_excs_summary);
    } catch (err) {
      console.error(err.message);
    }
  };

  useEffect(() => {
    getCourses();
    getSchoolNameByID();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div className="student-progress-container pl-4 pr-4">
      {schoolCourses && (
        <>
          <div className="school-name-container flex items-center gap-2">
            {!showBack && (
              <ArrowBackIcon
                className="back-btn hover:cursor-pointer"
                onClick={() => navigate(-1)}
              />
            )}
            <span className="school-name text-[35px] font-bold">{school}</span>
          </div>
          <div className="course-container flex gap-4 mt-4">
            <Box sx={{ width: "100vw" }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Course</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={course}
                  label="Course"
                  onChange={(e) => setCourse(e.target.value)}
                >
                  {schoolCourses.map((course, index) => (
                    <MenuItem key={course.crs_id} value={course.crs_id}>
                      {course.crs_title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <button
              className="course-select-submit-btn bg-blue-500 rounded-md hover:bg-blue-700 w-[100px] text-white"
              onClick={getStudentCourseData}
            >
              Submit
            </button>
          </div>
        </>
      )}

      {schoolData && (
        <>
          <TopWidgetsStudentsProgress schoolData={schoolData} />
          {/* <Bar options={options} data={data} /> */}
          {course && studentDetails.length === 0 ? (
            <div className="flex justify-center items-center h-[500px]">
              <Typography variant="h5" className="text-gray-400">
                No data available
              </Typography>
            </div>
          ) : (
            <StudentProgressDataTable
              course={course}
              studentDetails={studentDetails}
            />
          )}
        </>
      )}
    </div>
  );
};
